import { IActions, Context } from './actions.types';
// import { AppConstants } from '@/shared/app.constants';
import { Notification, INotification } from '@/entities';
export const actions: IActions = {
    /** set the selected review */
    setReviewId(context: Context, id: number) {
        context.commit('setSelectedReview', id);
    },
    /*** Get data */
    getData(context: Context, id: number) {
        if(id) {
            return this.$services.reviewinternal.getReviewData(id)
            .then((result: any) => {
                context.commit('setHeader', result);
                return this.$services.reviewinternal.getDueDiligenceData(id)
                .then((data: any) => {
                    context.commit('setDueDiligenceData', data);
                    return this.$services.reviewinternal.getBudgetData(id).then((res: any) => {
                        context.commit('setBudgetData', res);
                        return res;
                    });
                });
            });
        }
    },
    getDataByApplication(context: Context, payload: any) {
        if (payload.id && payload.entity) {
            return this.$services.reviewinternal.getReviewDataByApplication(payload.id, payload.entity)
            .then((result: any) => {
                if (result != null) {
                    var template = result.template.reduce((obj: any, tmpl: any) => {
                        obj[tmpl.Key] = tmpl.Value;
                        return obj;
                    }, {});
                    context.commit('setTemplate', template);
                    context.commit('refreshTemplates');
                    context.commit('setSelectedReview', result.info.InternalReviewId);
                    context.commit('setHeader', result.info);
                    context.commit('setDueDiligenceData', result.dueDiligence);
                    context.commit('setBudgetData', result.budget);
                    context.commit('setReviewSections', result.reviewSections);
                }
            });
        }
    },
    /** Get the template */
    getTemplate(context: Context, id: number) {
        if(id) {
            return this.$services.reviewinternal.getReviewTemplate(id)
            .then((data: any) => {
                context.commit('setTemplate', data);
                context.commit('refreshTemplates');
            });
        }
    },
    resetTabs(context: Context): void {
        context.commit('resetActiveTab');
    },
    updateDDactiveTab(context: Context, payload: string): void {
        context.commit('setActiveKey', payload)
    },
    updateBudgetActiveKey(context: Context, payload: string): void {
        context.commit('setBudgetActiveKey', payload)
    },
    updateMainTab(context: Context, payload: string): void {
        context.commit('setTabKey',payload);
    },
    /** update the state while switch the language */
    updateLanguage(context: Context, payload: string): void {
        context.commit('setLanguage', payload)
        context.commit('refreshTemplates')
    },
    /** create new review */
    create(context: Context, payload: any){        
        return this.$services.reviewinternal.saveReviewData(payload)
            .then((data: any) => {
                if(data.Result === 'OK') {
                    // context.commit('setNotification', {text: 'Saved successfully', color: 'success'});
                    return data.Record;                    
                } else {
                    context.commit('application/setNotification', 
                        new Notification({ snack: true, text: data.Message, isHtml: true, color: 'error' } as INotification), 
                        { root: true }
                    );
                    return {};
                }
            });
    },
    /** save the review form data */
    saveReviewData(context: Context, payload: any): any {
        if(payload.id && payload.entity) {
            return this.$services.reviewinternal.updateReviewData(payload.id, payload.data, payload.entity)
                .then((data: any) => {
                    if(data.Result === 'OK') {
                        context.commit('setDueDiligenceData', data.Record);
                        if (payload.context === 'save') {
                            context.commit('application/setNotification', new Notification({ snack: true, text: 'Saved successfully', color: 'success' } as INotification),  { root: true });
                        }
                        return data;
                    } else {
                        context.commit('application/setNotification', new Notification({ snack: true, text: data.Message, color: 'error' } as INotification),  { root: true });
                    }
                });
        } 
    },
    dirtySaveDiligence(context: Context, payload: any) {
        if(payload.id) {
            context.commit('application/updateOverlay', true, { root: true });
            return this.$services.reviewinternal.updateReviewData(payload.id, payload.data, payload.entity)
                .then((data: any) => {
                    if(data.Result === 'OK') {
                        context.commit('setDueDiligenceData', data.Record);
                        context.commit('application/updateOverlay', false, { root: true });
                        return data;
                    } else {
                        context.commit('application/setNotification', new Notification({ snack: true, text: data.Message, color: 'error', isHtml: true } as INotification),  { root: true });
                    }
                });
        } 
    },
    submit(context: Context, payload: any){
        return this.$services.reviewinternal.submitReviewData(payload.id, payload.context, payload.data, payload.entity)
            .then((data: any) => {
                if(data.Result === 'OK') {
                    context.commit('application/setNotification', new Notification({ snack: true, text: 'Submitted successfully', color: 'success', isHtml: true } as INotification),  { root: true });
                    return data.Record;
                } else {
                    context.commit('application/setNotification', new Notification({ snack: true, text: data.Message, color: 'error', isHtml: true } as INotification),  { root: true });                    
                }
            });
    },
    saveBudgetReview(context: Context, payload: any): any {
        if(payload.id && payload.entity) {
            return this.$services.reviewinternal.updateBudgetReview(payload.id, payload.data, payload.entity)
                .then((data: any) => {
                    if(data.Result === 'OK') {
                        context.commit('setBudgetData', data.Record);
                        if (payload.context === 'save') {
                            context.commit('application/setNotification', new Notification({ snack: true, text: 'Saved successfully', color: 'success' } as INotification),  { root: true });
                        }
                        return data;
                    } else {
                        context.commit('application/setNotification', new Notification({ snack: true, text: data.Message, color: 'error' } as INotification),  { root: true });
                    }
                });
        } 
    },
    dirtySaveBudgetReview(context: Context, payload: any) {
        if(payload.id && payload.entity) {
            context.commit('application/updateOverlay', true, { root: true });
            return this.$services.reviewinternal.updateBudgetReview(payload.id, payload.data, payload.entity)
                .then((data: any) => {
                    if(data.Result === 'OK') {
                        context.commit('setBudgetData', data.Record);
                        context.commit('application/updateOverlay', false, { root: true });
                        return data;
                    } else {
                        context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: data.Message, color: 'error' } as INotification),  { root: true });
                    }
                });
        }
    },
    getApplicationSection(context: Context, payload: any): any {
        if(payload.id && payload.entity) {
            const service = payload.entity == "ConceptNote" ? this.$services.conceptNote : this.$services.application;
            return service.getApplicationData(payload.id)
                .then((appHeader: any) => {
                    context.commit('setViewAppHeader', { entity: payload.entity, data: appHeader });
                    return service.getTemplate(appHeader.InitiativeCallId)
                        .then((tmpl: any) => {
                            context.commit('setViewAppTemplate', tmpl);
                            return service.getTechnicalApplication(payload.id)
                                .then((data: any) => {
                                    context.commit('setViewAppData', data);
                                    return data;
                                });
                        });
                });
        }
    }
}